import { Typography, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Colors } from 'constants/colors'
import { Link } from 'react-router-dom'

const ContainerStyle = styled('div')({
  width: '100%',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  position: 'relative',
})

const GridStyle = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const LinkStyle = styled(Link)({
  color: Colors.gray,
  transition: 'transform .2s',
  position: 'relative',
  textDecoration: 'none',
  '::before': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '2px',
    borderRadius: '4px',
    backgroundColor: Colors.darkGray,
    bottom: '0',
    left: '0',
    transformOrigin: 'right',
    transform: 'scaleX(0)',
    transition: 'transform .3s ease-in-out',
  },
  ':hover::before': {
    transformOrigin: 'left',
    transform: 'scaleX(1)',
  },
  ':hover': {
    color: Colors.darkDeepGray,
  },
})

const PageTitle = styled(Typography)({
  fontSize: '38px',
  fontWeight: 700,
  color: Colors.white,
  letterSpacing: '1.2px',
})

const SocialMediaContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const ConnectPageStyle = {
  ContainerStyle,
  PageTitle,
  SocialMediaContainer,
  LinkStyle,
  GridStyle,
}

export default ConnectPageStyle
